import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import CurFt from '../../components/CurFt';
import { Plus, Minus } from "lucide-react";
import Moment from 'moment';
import { Dialog } from "@headlessui/react";
import { toast } from 'react-hot-toast';
import WalletUtils from "../../utils/walletUtils";
// import { getapiKey } from "../../api/axios";
import { usePaymentProcess } from "../../services/usePaymentProcess";
import { useDispatch, useSelector } from "react-redux";
import { CheckCircle, CircleX } from "lucide-react";

import {
  DoBNPLCredit,
  clearBNPLError,
} from '../wallet/walletSlice';

function FareSummary(prop) {
  const dispatch = useDispatch();
  const [loading, setloading] = useState(0);
  const [loadingfee, setloadingfee] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { walletbnplStatus, walletbnplData } = useSelector((state) => state.wallet);
  const segments = location.pathname.split("/").filter(Boolean);
  let BookingData = prop.BookingData
  let params = prop.params
  let fare = prop.fare
  let user = prop.user
  let review = prop?.review || false
  let TotalSSR = 0;
  let TotalMealPrice = 0;
  let TotalBagPrice = 0;
  let SeatPrice = 0;
  if (prop.TotalSSR) {
    TotalSSR = prop.TotalSSR
  }
  if (prop.TotalMealPrice) {
    TotalMealPrice = prop.TotalMealPrice
  }
  if (prop.TotalBagPrice) {
    TotalBagPrice = prop.TotalBagPrice
  }
  if (prop.SeatPrice) {
    SeatPrice = prop.SeatPrice
  }
  let MF = 0;
  let OT = 0;
  let MFT = 0;
  let YQ = 0;
  let YR = 0;
  let AGST = 0;
  let CRF = 0;
  let FixedMarkUp = 0
  let GSTOnMarkUp = 0
  let TotalTaxes = 0
  if (BookingData.length > 0) {
    BookingData.map(items => {
      items.FareLists.FareBreak.map(item => {
        MF += parseFloat(item.TaxBR.MF)
        MFT += parseFloat(item.TaxBR.MFT)
        OT += parseFloat(parseFloat(item.TaxBR.OT) + parseFloat(item.agent_markup) + parseFloat(item.CommissionEarned) + parseFloat(item.TDSEarn))
        YQ += parseFloat(item.TaxBR.YQ)
        YR += parseFloat(item.TaxBR.YR)
        AGST += parseFloat(item.TaxBR.AGST)
        CRF += parseFloat(item.TaxBR?.CRF || 0) ///Reissue Fees tax
        FixedMarkUp += parseFloat(item.FixedMarkUp)
        GSTOnMarkUp += parseFloat(item.GSTOnMarkUp)
        // TotalTaxes += parseFloat(parseFloat(item.GSTOnMarkUp) + parseFloat(item.FixedMarkUp) + parseFloat(item.MF) + item.MFT + item.OT + item.YQ + item.YR + item.AGST + item.CommissionEarned + item.TDSEarn)
        TotalTaxes += parseFloat(parseFloat(item.GSTOnMarkUp) + parseFloat(item.FixedMarkUp) + parseFloat(item.Tax) + parseFloat(item.CommissionEarned) + parseFloat(item.TDSEarn))
      })
    })
  }
  const [paymentMode, SetpaymentMode] = useState("1");
  const paymentModeHandle = (event) => {
    const { value, checked } = event.target;
    SetpaymentMode(value)
  }
  const [Savepaxloading, setSavepax] = useState(false)
  const [isSectorModalOpen, setIsModalSector] = useState(false);
  const [errorMessage, setErrorMessage] = useState('loading');
  const [paymentHookStatus, setpaymentHookStatus] = useState(null);
  const [walletpaymentHookStatus, SetwalletpaymentStatus] = useState(null);
  const { handleProceed } = usePaymentProcess({
    SetErrorMessage: setErrorMessage,
    setpaymentHookStatus: setpaymentHookStatus,
    SetwalletpaymentStatus: SetwalletpaymentStatus,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    let remark = e.target.remark.value;
    let txnid = "TXN" + Date.now()

    const hash = WalletUtils.walletCode(txnid, txnid, ((fare.PendingAmount)).toFixed(2), user?.UserData?.name, user?.UserData?.mobile, user?.UserData?.email, "BNPL Pending Payment");
    // const hash = WalletUtils.walletCode(txnid, txnid, ((fare.TotalGrand) - fare.BookAmt).toFixed(2), user?.UserData?.name, user?.UserData?.mobile, user?.UserData?.email, "BNPL Pending Payment");
    // const decrypt = decryptAES('a3a83c379525b1251c7a2660c6ac120a', getapiKey(), getapiKey());
    const customerInfo = {
      txnid: txnid,
      amount: ((fare.PendingAmount)).toFixed(2),
      // amount: ((fare.TotalGrand) - fare.BookAmt).toFixed(2),
      name: user?.UserData?.name,
      email: user?.UserData?.email,
      phone: user?.UserData?.mobile,
      productinfo: "BNPL Pending Payment",
      surl: "http://localhost:3001/payment/payment-success",
      furl: "http://localhost:3001/payment/payment-success",
      udf1: BookingData[0].BookingID,
      udf2: "4",
      udf3: "Web-B2B",
      udf4: user?.UserData?.user?.id, // customer id
      udf5: user?.UserData?.user?.AgencyID,
      udf6: BookingData[0].Currncy,
      udf7: "",
      udf8: "",
      udf9: "",
      udf10: "",
      securecode: hash,
    };
    if (remark === '') {
      toast.error('Enter your remarks', { autoClose: 2000 });
      return false;
    }

    if (paymentMode === '1') {
      let BNPDue = {
        "customer_id": BookingData[0].customer_id,
        "amount": ((fare.PendingAmount)).toFixed(2),
        // "amount": ((fare.TotalGrand) - fare.BookAmt).toFixed(2),
        "currency": BookingData[0].Currncy,
        "reference_id": BookingData[0].BookingID,
        "description": "BNPL credit back"
      }
      setSavepax(true)
      setIsModalSector(true)
      dispatch(clearBNPLError());
      dispatch(DoBNPLCredit({ BNPDue })).unwrap();
    } else {
      setSavepax(true)
      setIsModalSector(true)
      handleProceed(customerInfo);
    }

  };

  useEffect(() => {
    setTimeout(() => {
      if (paymentHookStatus === 'success') {
        let BNPDue = {
          "customer_id": BookingData[0].customer_id,
          "amount": ((fare.PendingAmount)).toFixed(2),
          // "amount": ((fare.TotalGrand) - fare.BookAmt).toFixed(2),
          "currency": BookingData[0].Currncy,
          "reference_id": BookingData[0].BookingID,
          "description": "BNPL credit back"
        }
        dispatch(clearBNPLError());
        dispatch(DoBNPLCredit({ BNPDue })).unwrap();
      } else if (paymentHookStatus === 'paymentfailed') {
        dispatch(clearBNPLError());
        setErrorMessage('paymentfailed')
        setSavepax(false)
      }
    }, 3000);

  }, [paymentHookStatus]);

  useEffect(() => {
    if (walletbnplStatus === true) {
      setErrorMessage('success')
    } else if (walletbnplStatus === false) {
      setErrorMessage('paymentfailed')
      setSavepax(false)
      toast.error(walletbnplData?.message, { autoClose: 5000 });
    }
  }, [walletbnplStatus, walletbnplData]);
  const ViewTicketDetails = () => {
    window.location.reload()
  }
  const [AddonBNPL, SetAddonBNPL] = useState(0);
  const [AddonBNPLGST, SetAddonBNPLGST] = useState(0);

  useEffect(() => {
    if (segments[1] === 'itinerary') {
      let TotalSSRBNPL = (parseFloat(TotalSSR) + parseFloat(SeatPrice)) || 0
      let ProAmtCat = ((TotalSSRBNPL * fare.ProFee) / 100);
      let GSTOnProTax = ((ProAmtCat * 18) / 100);
      SetAddonBNPL(ProAmtCat);
      SetAddonBNPLGST(GSTOnProTax);
    }
  }, [TotalSSR, SeatPrice, fare]);

  return (
    <>
      <div className="bg-white  rounded-lg shadow p-4 space-y-4">
        <h3 className="font-semibold">Fare Summary</h3>
        <hr className="mx-n3" />
        <ul className="list-unstyled">

          {BookingData.map((citem, keys) => (

            <React.Fragment key={keys}>
              <li key={keys + 'segmentkey'} className="mb-2 font-weight-600 text-sm">
                <div className="flex items-center gap-2 text-gray-800">
                  <span className="font-medium">{citem.SoCode} - {citem.DeCode}</span>

                  {loading != (keys + 1) && (
                    <Plus
                      onClick={() => setloading(keys + 1)}
                      className="w-4 h-4 text-gray-600"
                    />
                  )}

                  {loading == (keys + 1) && (
                    <Minus
                      onClick={() =>
                        setloading(loading == keys + 1 ? 0 : keys + 1)
                      }
                      className="w-4 h-4 text-gray-600"
                    />
                  )}

                  <span className="ml-auto text-sm font-medium text-gray-900">
                    <CurFt
                      currency={fare?.symbol || "INR"}
                      price={citem.FareLists.BaseFare}
                    />
                  </span>
                </div>



              </li>
              {citem.FareLists.FareBreak.map((fareitem, keyss) => (
                <React.Fragment key={keyss}>
                  {loading == (keys + 1) && (
                    <li key={keyss + 'keysskeyss'} className="mb-2 text-sm ">{fareitem.PaxType} x {fareitem.PassengerCount}
                      <span className="float-right text-sm font-weight-500 text-dark"><CurFt currency={fare?.symbol || "INR"} price={fareitem.BaseFare} /></span>
                    </li>
                  )}
                </React.Fragment>

              ))}
            </React.Fragment>

          ))}
          <li className="mb-2 text-sm">
            <div className="flex items-center gap-2 text-gray-800">
              <span className="font-medium">Fee &amp; Surcharges</span>
              {!loadingfee && (
                <Plus
                  onClick={() => setloadingfee(true)}
                  className="w-4 h-4 text-gray-600"
                />
              )}
              {loadingfee && (
                <Minus
                  onClick={() =>
                    setloadingfee(loadingfee ? false : true)
                  }
                  className="w-4 h-4 text-gray-600"
                />
              )}

              <span className="ml-auto text-sm font-medium text-gray-900">
                <CurFt
                  currency={fare?.symbol || "INR"}
                  price={
                    fare.FeeSurcharges +
                    fare.Totalagentmarkup +
                    fare.TotalDiscount +
                    fare.ExtraServiceFee -
                    fare.OtherDiscount
                  }
                />
              </span>
            </div>

            {loadingfee && (
              <div
                style={{
                  overflowX: "hidden",
                  overflowY: "auto",
                  height: "150px",
                  width: "100%",
                }}
              >
                <table className="table-sm table-bordered" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th className="text-1">Type</th>
                      <th className="text-right text-1">Fare</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-1">MF</td>
                      <td className="text-right text-1">
                        <CurFt currency={fare?.symbol || "INR"} price={MF} />
                      </td>
                    </tr>
                    <tr>
                      <td className="text-1">MFT</td>
                      <td className="text-right text-1">
                        <CurFt currency={fare?.symbol || "INR"} price={MFT} />
                      </td>
                    </tr>
                    {fare.displayServiceFee == 1 ? (
                      <tr>
                        <td className="text-1">OT</td>
                        <td className="text-right text-1">
                          <CurFt
                            currency={fare?.symbol || "INR"}
                            price={OT + fare.TotalDiscount + fare.ExtraServiceFee}
                          />
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td className="text-1">OT</td>
                        <td className="text-right text-1">
                          <CurFt
                            currency={fare?.symbol || "INR"}
                            price={OT + fare.TotalDiscount}
                          />
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td className="text-1">Fuel Surcharge</td>
                      <td className="text-right text-1">
                        <CurFt currency={fare?.symbol || "INR"} price={YQ} />
                      </td>
                    </tr>
                    <tr>
                      <td className="text-1">Carrier Misc Fee</td>
                      <td className="text-right text-1">
                        <CurFt currency={fare?.symbol || "INR"} price={YR} />
                      </td>
                    </tr>
                    <tr>
                      <td className="text-1">Airline Tax</td>
                      <td className="text-right text-1">
                        <CurFt currency={fare?.symbol || "INR"} price={AGST} />
                      </td>
                    </tr>
                    {CRF > 0 && (
                      <tr>
                        <td className="text-1">Reissue Tax</td>
                        <td className="text-right text-1">
                          <CurFt currency={fare?.symbol || "INR"} price={CRF} />
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td className="text-1">Service Fee</td>
                      <td className="text-right text-1">
                        <CurFt currency={fare?.symbol || "INR"} price={FixedMarkUp} />
                      </td>
                    </tr>
                    <tr>
                      <td className="text-1">Tax on Service fee</td>
                      <td className="text-right text-1">
                        <CurFt currency={fare?.symbol || "INR"} price={GSTOnMarkUp} />
                      </td>
                    </tr>
                    {fare.displayServiceFee == 2 && fare.ExtraServiceFee > 0 && (
                      <tr>
                        <td className="text-1">Txn Fee</td>
                        <td className="text-right text-1">
                          <CurFt currency={fare?.symbol || "INR"} price={fare.ExtraServiceFee} />
                        </td>
                      </tr>
                    )}
                    {fare.OtherDiscount > 0 && (
                      <tr>
                        <td className="text-1">Discount(-)</td>
                        <td className="text-right text-1">
                          <CurFt currency={fare?.symbol || "INR"} price={fare.OtherDiscount} />
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td className="font-weight-500 text-dark text-1">Total</td>
                      <td className="text-right text-1 font-weight-500 text-dark">
                        <CurFt
                          currency={fare?.symbol || "INR"}
                          price={
                            TotalTaxes +
                            fare.Totalagentmarkup +
                            fare.TotalDiscount +
                            fare.ExtraServiceFee -
                            fare.OtherDiscount
                          }
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </li>

          {(fare.TotalSSR + TotalSSR + SeatPrice) > 0 && (
            <li className="mb-2">Meal, Baggage & Seat
              <span className="float-right text-2 font-weight-500 text-dark">
                <CurFt currency={fare?.symbol || "INR"} price={fare.TotalSSR + TotalSSR + SeatPrice} />
              </span><br />
              <small className="text-muted">
                {(fare.TotalMealPrice + TotalMealPrice) > 0 && (
                  <>
                    Meal - {fare.TotalMealPrice + TotalMealPrice}<br></br>
                  </>
                )}
                {(fare.TotalBagPrice + TotalBagPrice) > 0 && (
                  <>
                    Baggage - {fare.TotalBagPrice + TotalBagPrice}<br></br>
                  </>
                )}
                {(fare.TotalSeatPrice + SeatPrice) > 0 && (
                  <>
                    Seat - {fare.TotalSeatPrice + SeatPrice}
                  </>
                )}
              </small>
            </li>
          )}
          {fare?.convenience > 0 && (
            <li className="mb-2 text-gray-800">Convenience fee<span className="float-right text-2 font-weight-500 text-gray-800"><CurFt currency={fare?.symbol || "INR"} price={fare.convenience || 0} /> </span></li>
          )}
          {fare.CouponDiscount > 0 && (
            <li className="mb-2 text-blue-500">Coupon Applied<span className="float-right text-2 font-weight-500 text-blue-500">-<CurFt currency={fare?.symbol || "INR"} price={fare.CouponDiscount} /> </span></li>
          )}
          {fare?.Couponapplyon !== 5 && fare.TotalDiscount > 0 && (
            <li className="mb-2 text-blue-500">Discount Applied<span className="float-right text-2 font-weight-500 text-blue-500">-<CurFt currency={fare?.symbol || "INR"} price={fare.TotalDiscount} /> </span></li>
          )}
          {fare?.RSSR < 0 && (
            <li className="mb-2 font-medium text-sm">Refundable Ancillaries<span className="float-right font-weight-500 text-dark"><CurFt currency={fare?.symbol || "INR"} price={fare.RSSR} /> </span></li>
          )}
          {fare?.ARF > 0 && (
            <li className="mb-2 font-medium text-sm">Airline Reissue Fee<span className="float-right font-weight-500 text-dark"><CurFt currency={fare?.symbol || "INR"} price={fare.ARF} /> </span></li>
          )}

        </ul>

        <div className="flex justify-between text-lg font-bold border-t pt-2 pb-2">
          <span>Amount to Pay</span>
          {review ? (
            <>
              <span><CurFt currency={fare?.symbol || "INR"} price={(fare.TotalGrand + fare.ExtraServiceFee + fare.Totalagentmarkup + TotalSSR + SeatPrice) - (fare.OtherDiscount + fare.CouponDiscount)} /></span>
            </>
          ) : (
            <>
              <span><CurFt currency={fare?.symbol || "INR"} price={(fare.TotalGrand + fare.ExtraServiceFee + TotalSSR + SeatPrice) - (fare.OtherDiscount + fare.CouponDiscount)} /></span>
            </>
          )}

        </div>
        {fare.BookAmt > 0 && segments[1] !== 'booking-confirmation' && fare.BookOffline === false && (
          <>
            <h3 className="font-semibold text-blue-600">Booking Option</h3>
            <div className="flex items-center gap-2 text-gray-800">
              <span className="font-normal">One Time Payment</span>
              <span className="ml-auto text-sm font-medium text-gray-900">
                {review ? (
                  <>
                    <span><CurFt currency={fare?.symbol || "INR"} price={(fare.TotalGrand + fare.ExtraServiceFee + fare.Totalagentmarkup + TotalSSR + SeatPrice) - (fare.OtherDiscount + fare.CouponDiscount)} /></span>
                  </>
                ) : (
                  <>
                    <span><CurFt currency={fare?.symbol || "INR"} price={(fare.TotalGrand + fare.ExtraServiceFee + TotalSSR + SeatPrice) - (fare.OtherDiscount + fare.CouponDiscount)} /></span>
                  </>
                )}

              </span>
            </div>
            <div className="flex items-center gap-2 text-gray-800 border-b pb-2">
              <span className="font-normal">Part Payment</span>
              <span className="ml-auto text-sm font-medium text-gray-900">
                &nbsp;
              </span>
            </div>
            <div className="flex items-center gap-2 text-gray-800 pb-2 pt-2">
              <span className="text-sm">Bookable Amount</span>
              <span className="ml-auto text-sm font-normal text-gray-900">
                <CurFt currency={fare?.symbol || "INR"} price={(fare.BookAmt)} />
              </span>
            </div>
            <div className="flex items-center gap-2 text-gray-800 pb-2">
              <span className="text-sm">Processing Fee</span>
              <span className="ml-auto text-sm font-normal text-gray-900">
                <CurFt currency={fare?.symbol || "INR"} price={(fare.ProAmt + AddonBNPL)} />
              </span>
            </div>
            <div className="flex items-center gap-2 text-gray-800 pb-2">
              <span className="text-sm">GST</span>
              <span className="ml-auto text-sm font-normal text-gray-900">
                <CurFt currency={fare?.symbol || "INR"} price={(fare.GSTOnPro + AddonBNPLGST)} />
              </span>
            </div>
            <div className="flex items-center gap-2 text-gray-800 border-t pb-2">
              <span className="font-semibold">Pay Now</span>
              <span className="ml-auto text-sm font-semibold text-gray-900">
                <CurFt currency={fare?.symbol || "INR"} price={(fare.BookAmt + fare.ProAmt + fare.GSTOnPro + AddonBNPL + AddonBNPLGST)} />
              </span>
            </div>
            <div className="flex items-center gap-2 text-gray-800 pb-2 text-red-600">
              <span className="font-semibold text-sm">Pay balance by {Moment(fare.DLDate).format('MMM Do YYYY')}</span>
              <span className="ml-auto text-sm text-red-600 font-semibold text-gray-900">
                {fare.PendingAmount || 0 > 0 ? (
                  <CurFt currency={fare?.symbol || "INR"} price={(fare.PendingAmount)} />
                ) : (
                  <CurFt currency={fare?.symbol || "INR"} price={(fare.TotalGrand) - fare.BookAmt} />
                )}

                {/* <CurFt currency={fare?.symbol || "INR"} price={(fare.TotalGrand) - fare.BookAmt} /> */}
              </span>
            </div>
          </>
        )}

        {fare.PendingAmount > 0 && segments[1] === 'booking-confirmation' && fare.BookOffline === false && (
          <>
            {(fare.penalty_gst + fare.penalty_amount) > 0 && fare.PendingAmount > 0 && (
              <>
                <div className="flex items-center gap-2 text-gray-800">
                  <span className="font-medium">Pending Amount</span>
                  <span className="ml-auto font-medium text-gray-900">
                    <CurFt currency={fare?.symbol || "INR"} price={(fare.PendingAmount) - (fare.penalty_gst + fare.penalty_amount)} />
                  </span>
                </div>
                <div className="flex items-center gap-2 text-gray-800">
                  <span className="font-medium">Penalty</span>
                  <span className="ml-auto font-medium text-gray-900">
                    <CurFt currency={fare?.symbol || "INR"} price={(fare.penalty_gst + fare.penalty_amount)} />
                  </span>
                </div>
              </>
            )}

            <div className="flex items-center gap-2 text-gray-800 pb-2 text-red-600">
              <span className="font-semibold">Pay balance by {Moment(fare.DLDate).format('MMM Do YYYY')}</span>

              <span className="ml-auto text-red-600 font-semibold text-gray-900">
                <button
                  variant="contained"
                  size="large"
                  type="button"

                  onClick={() => setOpen((v) => !v)}
                  disabled={Savepaxloading}
                  className={`px-5 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white font-medium shadow transition ${Savepaxloading
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-red-500 hover:bg-red-600'
                    }`}
                >
                  Pay Pending <CurFt currency={fare?.symbol || "INR"} price={(fare.PendingAmount)} />
                  {/* Pay Pending <CurFt currency={fare?.symbol || "INR"} price={(fare.TotalGrand) - fare.BookAmt} /> */}
                </button>
              </span>
            </div>
            {open && (
              <form onSubmit={handleSubmit} className="mui-form">
                <div className="mt-3 w-1/2 ml-auto shadow p-4 rounded-lg">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-600">
                        Booking ID
                      </label>
                      <input
                        type="text"
                        value={BookingData[0].BookingID}
                        readOnly
                        className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                        placeholder="Booking ID"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600">
                        Pending Amount
                      </label>
                      <input
                        type="text"
                        value={(fare.PendingAmount)}
                        // value={(fare.TotalGrand) - fare.BookAmt}
                        readOnly
                        className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                        placeholder="Pending Amount"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600">
                        Remark
                      </label>
                      <input
                        type="text"
                        className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                        placeholder="Remark"
                        name="remark"
                      />
                    </div>
                    <div>
                      <ul className="flex gap-6 mt-6">
                        <li>
                          <label
                            htmlFor="FullPay"
                            className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-4 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                          >
                            <input
                              type="radio"
                              id="FullPay"
                              value="1"
                              name="paymentMode"
                              onChange={paymentModeHandle}
                              checked={paymentMode == 1}
                              className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                            />
                            <span className="text-sm font-medium text-gray-700">
                              Wallet
                            </span>
                          </label>
                        </li>
                        <li>
                          <label
                            htmlFor="Part"
                            className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-4 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                          >
                            <input
                              type="radio"
                              id="Part"
                              value="2"
                              name="paymentMode"
                              onChange={paymentModeHandle}
                              checked={paymentMode == 2}
                              className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                            />
                            <span className="text-sm font-medium text-gray-700">
                              Online
                            </span>
                          </label>
                        </li>
                      </ul>
                    </div>
                    <div className="flex gap-3">

                    </div>
                    <div className="flex gap-3">

                      <button
                        variant="contained"
                        size="large"
                        type="submit"
                        disabled={Savepaxloading}
                        className={`px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium shadow transition ${Savepaxloading
                          ? 'bg-gray-400 cursor-not-allowed'
                          : 'bg-blue-500 hover:bg-blue-600'
                          }`}
                      >
                        {Savepaxloading ? (
                          <>
                            Please wait...
                          </>
                        ) : (
                          <>
                            Proceed To Pay
                          </>

                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </>
        )}


        {/* <h3 className="text-4 mb-3 mt-4">Promo Code</h3>
                <div className="input-group form-group">
                    <input className="form-control" placeholder="Promo Code" aria-label="Promo Code" type="text" />
                    <span className="input-group-append">
                        <button className="btn btn-secondary" type="submit">APPLY</button>
                    </span>
                </div>
                <ul className="promo-code pre-scrollable">
                    <li><span className="d-block text-3 font-weight-600">FLTOFFER</span>Up to $500 Off on your booking. Hurry!
                        Limited period offer. <a className="text-1" href="">Terms & Conditions</a></li>
                    <li><span className="d-block text-3 font-weight-600">HOTOFFER</span>Up to $500 Off on your booking. Hurry!
                        Limited period offer. <a className="text-1" href="">Terms & Conditions</a></li>
                    <li><span className="d-block text-3 font-weight-600">SUMMEROFFER</span>Up to $500 Off on your booking.
                        Hurry! Limited period offer. <a className="text-1" href="">Terms & Conditions</a></li>
                    <li><span className="d-block text-3 font-weight-600">BIGOFFER</span>Up to $500 Off on your booking. Hurry!
                        Limited period offer. <a className="text-1" href="">Terms & Conditions</a></li>
                    <li><span className="d-block text-3 font-weight-600">FLTOFFER</span>Up to $500 Off on your booking. Hurry!
                        Limited period offer. <a className="text-1" href="">Terms & Conditions</a></li>
                    <li><span className="d-block text-3 font-weight-600">FLTOFFER</span>Up to $500 Off on your booking. Hurry!
                        Limited period offer. <a className="text-1" href="">Terms & Conditions</a></li>
                </ul> */}
      </div>


      <Dialog
        open={isSectorModalOpen}
        onClose={() => setIsModalSector(false)}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      >
        <div className="bg-white w-full max-w-md rounded-2xl shadow-lg p-6 flex flex-col items-center justify-center text-center">
          {(() => {
            if (errorMessage === "loading" || walletbnplStatus === 'loading') {
              return (
                <>
                  <h2 className="text-lg font-semibold border-b pb-2 w-full text-center">
                    Payment Process...
                  </h2>
                  <div className="mt-6 flex flex-col items-center justify-center">
                    <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
                    <p className="mt-4 text-gray-600">
                      Please do not go back or press any button. <br />
                      This might take a few seconds.
                    </p>
                  </div>
                </>
              )
            } else if (errorMessage === "paymentfailed") {
              return (
                <>
                  <CircleX className="w-16 h-16 text-red-500 mb-4" />
                  <h2 className="text-xl font-bold text-red-600">
                    Payment Failed
                  </h2>
                  <p className="mt-2 text-gray-700">
                    {errorMessage}!<br />
                    <span className="font-medium"> note down these Id for further support. RefId: </span>. <br />
                    {BookingData[0]?.BookingID} 😞
                  </p>
                  <button
                    onClick={() => setIsModalSector(false)}
                    className="mt-6 bg-blue-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-blue-700 transition"
                  >
                    Try Again
                  </button>
                </>
              )
            } else if (errorMessage === "success" && walletbnplStatus === true) {
              return (
                <>
                  <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
                  <h2 className="text-xl font-bold text-green-600">
                    Payment Success
                  </h2>
                  <p className="mt-2 text-gray-700">
                    Due Payment Success with booking Id-<br />
                    <span className="font-medium">{BookingData[0].BookingID}</span>. <br />
                    Have a great journey 😍
                  </p>
                  <button
                    onClick={ViewTicketDetails}
                    className="mt-6 bg-green-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-green-700 transition"
                  >
                    View Details
                  </button>
                </>
              )
            } else if (errorMessage === "userCancelled" || errorMessage === "failure") {
              return (
                <>
                  <CircleX className="w-16 h-16 text-red-500 mb-4" />
                  <h2 className="text-xl font-bold text-red-600">
                    Payment Failed
                  </h2>
                  <p className="mt-2 text-gray-700">
                    {errorMessage}!<br />
                    <span className="font-medium"> note down these Id for further support. RefId: </span>. <br />
                    {BookingData[0]?.BookingID} 😞
                  </p>
                  <button
                    onClick={() => setIsModalSector(false)}
                    className="mt-6 bg-blue-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-blue-700 transition"
                  >
                    Try Again
                  </button>
                </>
              )
            }
          })()}

        </div>
      </Dialog>
    </>
  )
}

export default FareSummary
